<template>
  <div id="plannermaster">
    <div class="container" style="margin-top: 10px">
      <div class="row header mb-2">
        <div class="col-lg-6">
          <h3 class="text-left mb-3">
            <!--{{$route.name}}-->
            {{ lang('Planner Master') }}
            <el-select v-model="ddlPlannerType" @change="getPlannerMasterList()" placeholder="Select Type">
              <el-option v-for="item in plannerTypeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </h3>
        </div>
        <div class="col-lg-6 actionDiv">
          <el-button type="primary" class="mt-2 mb-2" @click="openModel('NewMasterPlanner')">
            <i class="material-icons">playlist_add</i>
            {{ lang('New Master Planner') }}
          </el-button>

          <el-button type="primary" class="mt-2 mb-2" @click="assignSchool()">
            <i class="material-icons">layers</i>
            {{ lang('Assign Planner') }}
          </el-button>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="plannerMasterListInt.length < 1">
          <strong>{{ lang('No Data Found') }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="plannerMasterListInt.length > 0" class="datatable_group">
          <div class="col-lg-12 searchArea">
            <el-input class="search-datatable" :placeholder="lang('Search Level')" v-model="plannerMasterListFilters[0].value">
              <template slot="prepend">
                <i class="material-icons">search</i>
                <span>{{ lang('Search Level') }}</span>
              </template>
            </el-input>

            <el-input class="search-datatable" :placeholder="lang('Search Domain')" v-model="plannerMasterListFilters[1].value">
              <template slot="prepend">
                <i class="material-icons">search</i>
                <span>{{ lang('Search Domain') }}</span>
              </template>
            </el-input>
          </div>
          <data-tables :data="plannerMasterListInt" :action-col="plannerMasterListDelete" :filters="plannerMasterListFilters">
            <el-table-column
              v-for="plannerMasterListInfo in plannerMasterList"
              :prop="plannerMasterListInfo.prop"
              :label="plannerMasterListInfo.label"
              :key="plannerMasterListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
    <b-modal
      id="newPlannerModel"
      size="lg"
      :title="lang('New Planner Master')"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="newPlannerModel"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-6">
          <label>{{ lang('Level') }}</label>
          <el-select v-model="ddlNewLevel" @change="getPlannerMasterListGroupByDomain()" :placeholder="lang('Select Level')" class="newLevelSelect">
            <el-option v-for="item in plannerLevel" :key="item.CRS_Level" :label="item.CRS_Level" :value="item.CRS_Level"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6">
          <label>{{ lang('Type') }}</label>
          <el-select v-model="ddlNewPlannerType" :placeholder="lang('Select Type')" class="newTypeSelect" @change="newTypeSelectChange()">
            <el-option v-for="item in plannerTypeList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-12">
          <label>{{ lang('Domain') }}</label>
          <el-select v-model="ddlNewDomain" @change="ddlNewDomainChange()" :placeholder="lang('Select Level')" class="newIndicatorTypeSelect">
            <el-option v-for="item in ddlNewDomainList" :key="item.PlnMasDomain" :label="item.PlnMasDomain" :value="item.PlnMasDomain"> </el-option>
          </el-select>
          <input
            type="text"
            class="form-control inputNewDomainIsAddNew"
            v-if="inputNewDomainIsAddNew"
            :placeholder="lang('Fill in new Domain')"
            v-model="inputNewDomain"
          />
        </div>
        <div class="col-lg-12" v-if="inputNewNELGoalsVisible">
          <label>NEL {{ lang('Goals') }}</label>
          <input type="text" class="form-control" v-model="inputNewNELGoals" />
        </div>
        <div class="col-lg-12">
          <label>ITL {{ lang('Goals') }}</label>
          <input type="text" class="form-control" v-model="inputNewITLGoals" />
        </div>
        <div class="col-lg-9">
          <label>{{ lang('Indicator') }}</label>
          <input type="text" class="form-control" v-model="inputNewIndicator" />
        </div>
        <div class="col-lg-3">
          <label>{{ lang('Indicator Type') }}</label>
          <el-select v-model="ddlNewIndicatorType" :placeholder="lang('Select Level')" class="newIndicatorTypeSelect">
            <el-option v-for="item in indicatorType" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6">
          <label>{{ lang('Language') }}</label>
          <el-select v-model="ddlNewLang" :placeholder="lang('Select Language')" class="newLevelSelect">
            <el-option v-for="item in ddlNewLangList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6">
          <label>{{ lang('School Type') }}</label>
          <el-select v-model="ddlNewCourseType" :placeholder="lang('Select School Type')" class="newTypeSelect">
            <el-option v-for="item in ddlNewCourseTypeList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-12">
          <el-button type="primary" class="mt-2 mb-2" @click="saveNewPlannerMaster()">
            {{ lang('Save') }}
          </el-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import { lang } from '../locale'

export default {
  name: 'PlannerMaster',
  data() {
    return {
      plannerLevel: [],
      indicatorType: ['ITL', 'NEL'],
      ddlPlannerType: '',
      plannerTypeList: ['ITL', lang('OTHER')],
      inputNewNELGoalsVisible: true,

      inputNewDomain: '',
      ddlNewDomain: '',
      ddlNewDomainList: [],
      inputNewDomainIsAddNew: false,
      ddlNewLevel: '',
      inputNewNELGoals: '',
      inputNewITLGoals: '',
      inputNewIndicator: '',
      ddlNewIndicatorType: '',
      ddlNewPlannerType: '',

      ddlNewLangList: ['EN', 'CH'],
      ddlNewLang: '',
      ddlNewCourseTypeList: ['IB', 'NON IB'],
      ddlNewCourseType: '',

      plannerMasterListInt: [],
      plannerMasterList: [
        {
          prop: 'PlnMasDomain',
          label: lang('Domain'),
        },
        {
          prop: 'PlnMasGoalsNEL',
          label: lang('NEL Goals'),
        },
        {
          prop: 'PlnMasGoalsITL',
          label: lang('ITL NEL Goals'),
        },
        {
          prop: 'PlnMasIndicator',
          label: lang('Indicator'),
        },
        {
          prop: 'PlnMasIndicatorType',
          label: lang('IndicatorType'),
        },
        {
          prop: 'PlnMasLevel',
          label: lang('Level'),
        },
      ],
      plannerMasterListDelete: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.deletePlannerMaster(row.PlnMasID)
            },
            label: lang('Delete'),
          },
        ],
      },
      plannerMasterListFilters: [
        {
          value: '',
          prop: 'PlnMasLevel',
        },
        {
          value: '',
          prop: 'PlnMasDomain',
        },
      ],
    }
  },
  async created() {
    this.getCoursesLevel()
  },
  methods: {
    lang,
    async getCoursesLevel() {
      try {
        const response = await DataSource.shared.getAllCoursesLevel()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getAllCoursesLevel Error')
          } else if (response.code === '2') {
            console.log('getAllCoursesLevel no records return')
          } else {
            this.plannerLevel = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerMasterList() {
      try {
        const response = await DataSource.shared.getPlannerMaster('', this.ddlPlannerType, '')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: lang('Get Master Planner List: Error'),
            })
          } else if (response.code === '2') {
            this.plannerMasterListInt = []
          } else {
            this.plannerMasterListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async saveNewPlannerMaster() {
      try {
        if (
          this.ddlNewDomain === '' ||
          this.ddlNewLevel === '' ||
          this.inputNewITLGoals === '' ||
          this.inputNewIndicator === '' ||
          this.ddlNewIndicatorType === '' ||
          this.ddlNewPlannerType === '' ||
          this.ddlNewLang === '' ||
          this.ddlNewCourseType === ''
        ) {
          this.$notify({
            title: 'Require',
            message: lang('All Fields Required') + '...',
          })
        } else if (this.inputNewNELGoals === '' && this.ddlNewPlannerType === 'ITL') {
          this.$notify({
            title: 'Require',
            message: lang('All Fields Required') + '...',
          })
        } else if (this.ddlNewDomain === '-ADD NEW-' && this.inputNewDomain === '') {
          this.$notify({
            title: 'Require',
            message: lang('All Fields Required') + '...',
          })
        } else {
          let newDomain = ''

          if (this.ddlNewDomain === '-ADD NEW-') {
            newDomain = this.inputNewDomain
          } else {
            newDomain = this.ddlNewDomain
          }

          let newPlannerMasterObjJson = {
            Domain: newDomain,
            GoalsITL: this.inputNewITLGoals,
            GoalsNEL: this.inputNewNELGoals,
            Indicator: this.inputNewIndicator,
            IndicatorType: this.ddlNewIndicatorType,
            Level: this.ddlNewLevel,
            Type: this.ddlNewPlannerType,
            Lang: this.ddlNewLang,
            CourseType: this.ddlNewCourseType,
          }

          const response = await DataSource.shared.savePlannerMaster(JSON.stringify(newPlannerMasterObjJson))
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: lang('Save Master Planner List: Error'),
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: lang('Planner duplicated'),
              })
            } else {
              this.clearNewMasterPlannerModelInput()
              if (this.ddlPlannerType !== '') {
                this.getPlannerMasterList()
              }
              this.$refs.newPlannerModel.hide()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deletePlannerMaster(PlnMasID) {
      try {
        const response = await DataSource.shared.updatePlannerMaster(PlnMasID, 'Delete')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: lang('Delete Master Planner List: Error'),
            })
          } else {
            this.getPlannerMasterList()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getPlannerMasterListGroupByDomain() {
      try {
        if (this.ddlNewLevel !== '' && this.ddlNewPlannerType !== '') {
          this.ddlNewDomainList = []
          this.inputNewDomain = ''
          this.ddlNewDomain = ''
          this.inputNewDomainIsAddNew = false

          const response = await DataSource.shared.getPlannerMaster(this.ddlNewLevel, this.ddlNewPlannerType, 'GroupByDomain')
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: lang('Get Master Planner List Group By Domain: Error'),
              })
            } else if (response.code === '2') {
              let tempDdlNewDomainList = {
                PlnMasDomain: '-ADD NEW-',
              }

              this.ddlNewDomainList.push(tempDdlNewDomainList)
            } else {
              this.ddlNewDomainList = response.Table

              let tempDdlNewDomainList = {
                PlnMasDomain: '-ADD NEW-',
              }

              this.ddlNewDomainList.push(tempDdlNewDomainList)
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    openModel(value) {
      if (value === 'NewMasterPlanner') {
        this.clearNewMasterPlannerModelInput()
        this.$refs.newPlannerModel.show()
      }
    },
    clearNewMasterPlannerModelInput() {
      this.inputNewDomain = ''
      this.ddlNewDomain = ''
      this.ddlNewDomainList = []
      this.inputNewDomainIsAddNew = false
      this.ddlNewLevel = ''
      this.inputNewNELGoals = ''
      this.inputNewITLGoals = ''
      this.inputNewIndicator = ''
      this.ddlNewIndicatorType = ''
      this.ddlNewPlannerType = ''
      this.inputNewNELGoalsVisible = true
      this.ddlNewLang = ''
      this.ddlNewCourseType = ''
    },
    assignSchool() {
      this.$router.push({
        name: 'Planner Assign School',
      })
    },
    newTypeSelectChange() {
      if (this.ddlNewPlannerType === 'ITL') {
        this.inputNewNELGoalsVisible = true
      } else {
        this.inputNewNELGoals = ''
        this.inputNewNELGoalsVisible = false
      }

      this.getPlannerMasterListGroupByDomain()
    },
    ddlNewDomainChange() {
      if (this.ddlNewDomain === '-ADD NEW-') {
        this.inputNewDomainIsAddNew = true
      } else {
        this.inputNewDomainIsAddNew = false
      }
    },
  },
}
</script>

<style scoped>
.actionDiv {
  text-align: right;
}
.newIndicatorTypeSelect,
.newLevelSelect,
.newTypeSelect {
  width: 100%;
}
.searchArea .el-input-group {
  width: 50% !important;
}
.inputNewDomainIsAddNew {
  margin-top: 10px;
}
</style>
